import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { Code2, Server, LayoutTemplate, ShieldCheck } from "lucide-react";

const ICONS = [Code2, Server, LayoutTemplate, ShieldCheck];

const Stack = () => {
  const { t } = useLanguage();
  return (
    <section
      id="stack"
      data-testid="stack-section"
      className="py-24 sm:py-32 px-5 sm:px-8 bg-brand text-white relative overflow-hidden"
    >
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl" />
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-white/5 rounded-full blur-3xl" />

      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-px bg-white/70" />
              <span className="text-[11px] tracking-[0.25em] font-bold text-white/80">
                {t.stack.eyebrow}
              </span>
            </div>
            <h2
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight leading-tight"
              data-testid="stack-title"
            >
              {t.stack.title}
            </h2>
          </div>
          <p className="md:col-span-6 md:col-start-7 text-base sm:text-lg text-white/75 leading-relaxed">
            {t.stack.body}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.stack.groups.map((g, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={g.label}
                data-testid={`stack-group-${i}`}
                className="rounded-3xl bg-white/5 border border-white/10 p-6 hover:bg-white/10 hover:border-white/20 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-10 h-10 rounded-xl bg-white/10 flex items-center justify-center mb-5">
                  <Icon size={18} strokeWidth={1.5} />
                </div>
                <div className="text-[10px] tracking-[0.3em] font-bold text-white/60 mb-4">
                  {g.label.toUpperCase()}
                </div>
                <ul className="space-y-2">
                  {g.items.map((it) => (
                    <li
                      key={it}
                      className="flex items-center gap-2 text-sm text-white/90"
                    >
                      <span className="w-1 h-1 rounded-full bg-white/50" />
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Stack;
